<template>
  <div class="compliance-card">
    <div class="d-flex justify-content-center align-items-center modal-title-head">
      <div class="title-head">
        <p style="text-align: center">{{ $t("complianceList.form.compliancePreview") }}</p>
      </div>
      <svg
        @click="$bvModal.hide('compliance-data-modal')"
        class="closeComplianceData"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>
    <div>
      <div>
        <p class="compliance-title">{{ complianceData.name }}</p>

        <div class="compliance-description-container">
          <p class="compliance-description">
            {{
              complianceData.detail_list &&
              complianceData.detail_list.length > 0 &&
              complianceData.detail_list[0].type == "vaccine_document"
                ? "Document - Vaccine/PCR"
                : complianceData.detail_list[0] && complianceData.detail_list[0].type
                ? complianceData.detail_list[0].type
                : ""
            }}
          </p>
        </div>

        <div
          class="row-details mb-1"
          v-for="(question, i) in complianceData.detail_list"
          :key="i"
        >
            <div style="display: grid; gap: 16px">
                <div v-if="question.body" class="compliance-data mt-16">
                <p>{{ question.body }} </p>
                </div>

                <div v-else class="compliance-data mt-16">
                    <p>Document Binding: </p>
                    <p>{{ question.bind  }}</p>
                </div>
                <div v-if="question.pcr" class="compliance-data mt-16">
                    <p>PCR Validation Days: </p>
                    <p>{{ question.pcr.days  }}</p>
                </div>
            </div>
          <b-form-checkbox
            size="sm"
            class="comp-checkbox mt-16"
            v-for="answer in question.answers"
            :key="answer.id"
            v-model="answer.desired"
            plain
            disabled
          >
            {{ answer.text ? answer.text : "--" }}
          </b-form-checkbox>
        </div>
        <!-- <div style="display: grid; gap: 16px">
              <div class="compliance-data mt-16">
                <p>{{ question.body }} </p>
              </div>
  
              <div class="compliance-data mt-16">
                <p>{{ $t('announcements.grid.expiryTime') }}: </p>
                <p>{{ expiryDate }}</p>
              </div>
  
              <div class="compliance-data mt-18">
                <p style="white-space: nowrap;">{{ $t('announcements.grid.createdAt') }}: </p>
                <p style="white-space: nowrap;">{{ createdAt }} {{ $t('common.by').toLowerCase() }} ({{ createdby }})</p>
              </div>
            </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "viewAnnouncementData",
  components: {},
  props: ["complianceData"],
  data() {
    return {
      title: null,
      urgent: false,
      userTypes: [],
      areas: [],
      description: null,
      url: null,
      publishDate: null,
      expiryDate: null,
      createdAt: null,
      createdby: null,
    };
  },
  methods: {},
  computed: {
    ...mapGetters("users", ["getModalState"]),
    ...mapGetters("modal", ["getModalInfo"]),
  },
  watch: {
    getModalState(state) {
      state && this.$bvModal.hide("compliance-data-modal");
    },
  },
  async beforeMount() {
    console.log("this.complianceData", this.complianceData);
  },
};
</script>

<style lang="scss">
div#compliance-data-modal {
  div#compliance-data-modal___BV_modal_content_ {
    width: 500px !important;
    background: #ffffff;
    box-shadow: 0px 1px 40px 3px rgb(0 0 0 / 5%);
    border-radius: 26px !important;
    div#compliance-data-modal___BV_modal_body_ {
      padding: 40px 32px !important;
      .mt-16 {
        margin-top: 16px !important;
        }
      .modal-title-head {
        .title-head {
          font-weight: 700;
          font-size: 16px;
          line-height: 20px;
          margin: 0px 0 40px 0;
          color: #000000;
          p {
            font-weight: 700;
            font-size: 16px;
            margin-bottom: 0px !important;
          }
        }
      }

      .closeComplianceData {
        position: absolute;
        top: 32px;
        inset-inline-end: 32px;
        cursor: pointer;
      }

      .compliance-title {
        width: 416px;
        color: #4a4a4a;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        line-height: normal;
        margin: 0px 0 32px 0;
      }
      .compliance-user-type {
        margin-inline-end: 8px;
        display: inline-flex;
        height: 28px;
        padding-top: 11px;
        padding-inline-end: 11px;
        padding-bottom: 11px;
        padding-inline-start: 14px;
        align-items: center;
        flex-shrink: 0;
        border-radius: 31px;
        background: #e5e5e5;
        color: #4a4a4a;
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        letter-spacing: 0.25px;
        &:last-child {
          margin-inline-end: 0px !important;
        }
      }

      .urgent-compliance-user-type {
        margin-inline-end: 8px;
        display: inline-flex;
        height: 28px;
        padding-top: 11px;
        padding-inline-end: 11px;
        padding-bottom: 11px;
        padding-inline-start: 14px;
        align-items: center;
        gap: 14px;
        flex-shrink: 0;
        border-radius: 31px;
        background: var(--Error, #f46a6a);
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        line-height: 17px;
        letter-spacing: 0.25px;
      }
      .compliance-description-container {
        margin-bottom: 32px;
      }
      .compliance-description {
        width: 416px;
        word-break: break-word;
        margin-top: 32px;
        margin-bottom: 32px;
        color: #4a4a4a;
        flex-shrink: 0;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
      }

      .compliance-data {
        color: #4a4a4a;
        font-size: 16px;
        margin-bottom: 0px !important;
        line-height: 24px;
        display: flex;
        gap: 3px;
        // height: 11px;
        p {
          // height: 11px;
          display: flex;
          align-items: center;
        }
      }

      .compliance-url {
        margin-bottom: 32px;
      }
    }
  }
}
</style>
